import type { Product } from 'types/IProducts';

const sortFuturesByVolume = (
  products: Product[],
  futuresVolumes: Record<string, number>
) => {
  return [...products].sort((a, b) => {
    // Sort by volume in descending order (highest first)
    const aVolume = futuresVolumes[a.symbol] || 0;
    const bVolume = futuresVolumes[b.symbol] || 0;

    if (aVolume !== bVolume) {
      return bVolume - aVolume;
    }

    // Fallback to sort_priority if turnover values are equal
    const aSortPriority = a.ui_config?.sort_priority || 0;
    const bSortPriority = b.ui_config?.sort_priority || 0;
    return aSortPriority - bSortPriority;
  });
};

export { sortFuturesByVolume };
